import React, { useEffect } from 'react'
import {Routes, Route, Navigate} from 'react-router-dom'
import {OnboardingLayout} from '../../_metronic/layout/OnboardingLayout'
import Onboarding from '../pages/UserPages/Onboarding/Onboarding'
import { useDispatch, useSelector } from 'react-redux'
import { getUserData, getUserOnboardingData, userOnboarding } from '../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'
import { ROLES } from '../Utils/Constant/roles'

const UserOnboardingRoutes = () => {
  const dispatch = useDispatch();

  const user = useSelector(getUserData)
  const userOnboardingData = useSelector(getUserOnboardingData)

  useEffect(() => {
    if (user?.user?._id && (!userOnboardingData?.isComplete) && user?.user?.role === ROLES.OWNER) {
      dispatch(userOnboarding(userOnboardingData?.currentStep ? userOnboardingData?.currentStep : 1))
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.user?._id, userOnboardingData?.currentStep, userOnboardingData?.isFinished, userOnboardingData?.isComplete])

  return (
    <>
      <Routes>
        <Route element={<OnboardingLayout />}>
          <Route path='auth/*' element={<Navigate to='/onboarding' replace={true} />} />
          <Route path={'/onboarding'} element={<Onboarding />} />

          {/* <Route path='*' /> */}
          <Route path='*' element={<Navigate to='/error/404' />} />
        </Route>
      </Routes>
    </>
  )
}

export default UserOnboardingRoutes
